// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"6b3e9ebb","548":"c6bcf5c2"}[chunkId] + ".chunk.css";
};